<script>
import { sync } from 'vuex-pathify'
export default {
	computed: {
		searchDialog: sync('shop/searchDialog'),
	},
}
</script>

<template>
	<transition name="dialog">
		<div v-if="searchDialog" class="search-dialog">
			<div class="search-dialog-content">
				<div class="search-dialog-card">
					<div class="d-flex justify-end">
						<Button @click="searchDialog = false" icon small><v-icon>mdi-close</v-icon></Button>
					</div>
					<AutocompleteSearchField style="height: 52px" />
				</div>
			</div>
		</div>
	</transition>
</template>

<style scoped lang="scss">
.search-dialog {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 9999;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	padding-top: 15vh;
}

.dialog-enter-active,
.dialog-leave-active {
	transition: opacity 0.35s ease;
}

.dialog-enter,
.dialog-leave-to {
	opacity: 0;
}

.search-dialog-content {
	max-width: 720px;
	width: 100%;
	transition: transform 0.35s ease;
}

.dialog-enter .search-dialog-content,
.dialog-leave-to .search-dialog-content {
	transform: translateY(-100%);
}

.search-dialog-card {
	background: #fff;
	border-radius: 16px;
	padding: 8px 20px 20px;
	box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}
</style>

